import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ConnectorListView } from './ConnectorListView';
import { Topbar } from '@hum/icm-app/src/components/Topbar';
import { PlatformType, ConnectorConfig } from '@hum/types';
import { MaintenanceBanner } from '@hum/ui-library';
import { useFlags } from '@hum/icm-app/src/hooks/useFlags';
import clsx from 'clsx';

export type OnboardingConnectStepProps = {
  isOnboarding?: boolean;
};

export type ConnectorParams = {
  platformType?: string;
};

export function OnboardingConnectStep({
  isOnboarding = false,
}: OnboardingConnectStepProps) {
  let {
    platformType = PlatformType.AccountingSystem,
  } = useParams<ConnectorParams>();
  platformType = platformType.replace(/-/g, '_');

  const [
    selectedConnector,
    setSelectedConnector,
  ] = useState<ConnectorConfig | null>(null);
  const flags = useFlags();

  const maintenanceConnectorConfig = flags.enabled('connector-maintenance')
    ? (flags.value('connector-maintenance') as Record<string, any>)
    : null;

  const maintenanceConnectors = maintenanceConnectorConfig?.connectors || [];
  const showMaintenanceBanner =
    maintenanceConnectorConfig &&
    selectedConnector?.connectorType &&
    maintenanceConnectors.includes(selectedConnector.connectorType);

  return (
    <>
      <Topbar
        links={[]}
        title="Build your Data room"
        fixedBar
        background="bg-defaultBg"
        flow
      />
      {showMaintenanceBanner && (
        <div className="pt-16">
          <MaintenanceBanner
            warning
            title={
              maintenanceConnectorConfig?.title ||
              `${selectedConnector?.label} is currently experiencing intermittent issues`
            }
            message={
              maintenanceConnectorConfig?.message ||
              'If you have trouble connecting, please try again in 24 hours.'
            }
          />
        </div>
      )}
      <div className={clsx(showMaintenanceBanner ? 'pt-16' : 'pt-32')}>
        <div className="bg-defaultBg h-[calc(100vh_-_8rem)]">
          <ConnectorListView
            isOnboarding={isOnboarding}
            withTransitions
            platformType={platformType as PlatformType}
            onConnectorSelect={setSelectedConnector}
          />
        </div>
      </div>
    </>
  );
}
